module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Launch"
    },
    on: {
      "click": _vm.enterHome
    }
  }, [(_vm.ds_id || _vm.channel_id) ? [_c('div', {
    staticClass: "img",
    style: ('background-image:url(' + _vm.imgScr + ')')
  }), _vm._v(" "), (_vm.currentCount > 0) ? _c('span', {
    staticClass: "timeDown"
  }, [_vm._v(_vm._s(_vm.currentCount) + " 秒进入")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('p', [_vm._v("获取房间号失败，请检查链接")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66572c50"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/launch.vue
// module id = 223
// module chunks = 0